import React from "react";
import Select from "react-select";

const ImportHeader = ({ options, columns, changeColumn }) => {
  return (
    <thead>
      <tr>
        <th>#</th>
        {options.map((_, index) => {
          return (
            <th key={columns[index] ? columns[index].value : index}>
              <div style={{ width: 300 }}>
                <Select
                  isClearable
                  placeholder="Select field"
                  options={options}
                  value={columns[index]}
                  defaultValue={columns[index]}
                  onChange={(option) => {
                    changeColumn(option, index, columns[index]);
                  }}
                />
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default React.memo(ImportHeader);
